﻿﻿export interface IOrderTrackingDetails {
    //recipient info
    //tracking properties
    outboundTrackingNumber: string,
    outboundDateShipped: string,
    outboundDateDelivered: string,
    inboundTrackingNumber: string,
    inboundRslDateShipped: string,
    inboundRslDeliveredDate: string
}